import React, { useEffect } from "react";

import Modal from "@material-ui/core/Modal";
import "./style.css";
import AddMoreTickets from "../checkout/AddMoreTickets/AddMoreTickets";
import { useState } from "react";
import Payment from "../checkout/payment/Payment";
import { connect } from "react-redux";
import LoginBeforeCheckOut from "../checkout/LoginBeforeCheckout/LoginBeforeCheckOut";
import {
  GetDiscountData,
  removeAllEventDateDetails,
  ticktesCartItem,
} from "Actions/eventActions";
import Countdown from "react-countdown";

const CheckOutModal = ({
  openCheckOut,
  checkOutTimer,
  setOpenCheckOut,
  isLoggedIn,
  paymentIntent,
  GetDiscountData,
  ticktesCartItem,
  dispatch,
  Token,
  currentEventDetails,
  hasCheckoutQuery,
  paymentMessage,
  shoppingCartDetails
}) => {
  const [continueToCheckOut, setContinueToCheckOut] = useState(false);
  const [isNotLoggedIn, setIsNotLoggedIn] = useState(false);
  const [minutes, setMinutes] = useState(30);
  const [seconds, setSeconds] = useState(0);
  const [newCartItemsData, setNewCartItemsData] = useState([]);
  const [recurringData, setRecurringData] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);

  const ticketQty = newCartItemsData?.reduce(
    (a, c) => a + (c.DiscountQty === null ? 0 : Number(c.DiscountQty)),
    0
  );
  useEffect(() => {
    if (checkOutTimer) {
      // console.log("Hello world!", checkOutTimer);
      let myInterval = setInterval(() => {
        if (seconds > 0) {
          setSeconds((prev) => prev - 1);
        }
        if (seconds === 0) {
          if (minutes === 0) {
            clearInterval(myInterval);
          } else {
            setMinutes((prev) => prev - 1);
            setSeconds(59);
          }
        }
      }, 1000);
      return () => {
        clearInterval(myInterval);
      };
    }
  }, [minutes, seconds, paymentIntent]);

  useEffect(() => {
    console.log('Current Event Details updated:', currentEventDetails);
  }, [currentEventDetails]);

  useEffect(() => {
    const userId = localStorage.getItem("UserId");
    if (userId) {
      setIsNotLoggedIn(false);
    }
  }, [isLoggedIn, openCheckOut]);

  const searchParams = new URLSearchParams(window.location.search);
  const isEmbed = searchParams.get("embed") === "true";

  return (
    <div>
      <Modal
        open={openCheckOut}
        // onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className="checkout_modal">
          <div className={
              isEmbed
                ? "checkout_modal_container_embed"
                : "checkout_modal_container"
          }>
            {/* {CountDown()} */}
            {isNotLoggedIn && !localStorage.getItem("UserId") ? (
                <LoginBeforeCheckOut
                    setOpenCheckOut={setOpenCheckOut}
                    hasCheckoutQuery={hasCheckoutQuery}
                    currentEventDetails={currentEventDetails}
                />
            ) : continueToCheckOut ? (
                currentEventDetails && (
                    currentEventDetails.IsAnonymousAllowed === "False"
                        ? (
                            (!isLoggedIn || !localStorage.getItem("token")) ? (
                                // Instead of directly showing LoginBeforeCheckOut, just flag it
                                setIsNotLoggedIn(true)
                            ) : (
                                (() => {
                                  return (
                                      <Payment
                                          {...{ minutes, seconds, Token, setMinutes }}
                                          setContinueToCheckOut={setContinueToCheckOut}
                                          setOpenCheckOut={setOpenCheckOut}
                                          recurringData={recurringData}
                                          hasCheckoutQuery={hasCheckoutQuery}
                                      />
                                  );
                                })()
                            )
                        ) : (
                            (() => {
                              // ensure token is set right before Payment
                              if (!localStorage.getItem("token") && shoppingCartDetails.Token) {
                                localStorage.setItem("token", shoppingCartDetails.Token);
                              }
                              return (
                                  <Payment
                                      {...{ minutes, seconds, Token, setMinutes }}
                                      setContinueToCheckOut={setContinueToCheckOut}
                                      setOpenCheckOut={setOpenCheckOut}
                                      recurringData={recurringData}
                                      hasCheckoutQuery={hasCheckoutQuery}
                                      setIsNotLoggedIn={setIsNotLoggedIn}
                                  />
                              );
                            })()
                        )
                )
            ) : (
                <AddMoreTickets
                    {...{ minutes, setMinutes, seconds, Token}}
                    setIsNotLoggedIn={setIsNotLoggedIn}
                    setOpenCheckOut={setOpenCheckOut}
                    setContinueToCheckOut={setContinueToCheckOut}
                    setRecurringData={setRecurringData}
                    recurringData={recurringData}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    hasCheckoutQuery={hasCheckoutQuery}
                    paymentMessage={paymentMessage}
                />
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    results: state.loginResponse.results,
    isLoggedIn: state.loginResponse.isLoggedIn,
    currentEventDetails: state.eventReducer.currentEventDetails,
    cartItems: state.eventReducer.cartData,
    paymentIntent: state.eventReducer.paymentIntent,
    checkOutTimer: state.eventReducer.checkOutTimer,
    discountData: state.eventReducer.discountData,
    shoppingCartDetails: state.eventReducer.createshoppingCartDetails,
  };
};
const matchDispatchToProps = (dispatch) => {
  return {
    // AddToFavorite: () => dispatch(AddToFavorite),
    // SetCardData: () => dispatch(SetCardData),
    // LoginPopup: () => dispatch(LoginPopup),
    // currentEventTicketDetails,
    // ticktesCartItem,
    // GetDiscountDetails,
    GetDiscountData,
    ticktesCartItem,
    dispatch,
  };
};

export default connect(mapStateToProps, matchDispatchToProps)(CheckOutModal);
